export enum MovingDirection{None, Left, Right}